<div class="page-container" style="background-color: #fff;">
  <app-index-header></app-index-header>
  <div class="heroSection">
    <owl-carousel-o [style.direction]="('dir' | translate) === 'rtl' ? 'ltr' : 'ltr'" [options]="customOptions">
      <ng-template carouselSlide *ngFor="let slide of sliderInfo">
        <div class="heroText" [style.background-image]="'url('+slide.image+')'">
          <h1>{{slide.title | translate}}</h1>
          <p>{{slide.desc | translate}}</p>
          <div class="hero-buttons-container">
            <button class="secondary-button" (click)="scrollToServices()">{{"LOGIN.LOGIN_SLIDER_BTN1" |
              translate}}</button>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
  <div class="about-container">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 about-image-container">
          <img src="./assets/images/login/about.png" alt="about image">
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12  about-text-container">
          <h1>{{"LOGIN.LOGIN_ABOUT_TITLE" | translate}}</h1>
          <p>{{"LOGIN.LOGIN_ABOUT_DESC" | translate}}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Video Component Section -->
  <div class="video-section-container">
    <div class="container">
      <app-video></app-video>
    </div>
  </div>

  <app-hero></app-hero>
  <app-statistics></app-statistics>

  <app-index-services id="servicesSection"></app-index-services>
  <app-contact-form></app-contact-form>
  <app-index-footer [lang]="currLang"></app-index-footer>

  <div class="floating-whatsapp" (click)="openWhatsApp()">
    <img class="social" src="assets/images/login/whatsapp.png" alt="youtube" />
  </div>
</div>

<style>
  .floating-whatsapp {
    position: fixed;
    bottom: 40px;
    right: 40px;
    background-color: #FF69B4;
    /* Changed to pink */
    color: #ffffff;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
    z-index: 1000;
    transition: all 0.3s ease;
  }

  .floating-whatsapp i {
    font-size: 35px;
    color: #ffffff;
  }

  .floating-whatsapp:hover {
    transform: scale(1.1);
    background-color: #FF1493;
    /* Darker pink on hover */
  }

  [dir="rtl"] .floating-whatsapp {
    left: 40px;
    right: auto;
  }

  /* Video Section Styling */
  .video-section-container {
    padding: 20px 0 60px;
    background-color: #fff;
  }

  .section-title {
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 16px;
    color: #300458;
    line-height: 1.3;
    letter-spacing: 0px;
    text-transform: uppercase;
  }

  .section-subtitle {
    font-size: 16px;
    color: #300458;
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.3;
    letter-spacing: 0px;
  }

  /* Responsive adjustments */
  @media (max-width: 767px) {
    .video-section-container {
      padding: 40px 0;
    }

    .section-title {
      font-size: 24px;
    }

    .section-subtitle {
      font-size: 14px;
    }
  }
</style>